module.exports = __webpack_public_path__ + "fc7f075a10657e0bd9fc4792a92f2dd4.jpg";